import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  bg?: 'cream' | 'blush' | 'white';
  id?: string;
  className?: string;
  noPadding?: boolean;
}
export function SectionWrapper({
  children,
  bg = 'cream',
  id,
  className = '',
  noPadding = false
}: SectionWrapperProps) {
  const bgColors = {
    cream: 'bg-cream',
    blush: 'bg-blush',
    white: 'bg-white'
  };
  return <section id={id} className={`${bgColors[bg]} ${noPadding ? '' : 'py-16 md:py-24'} ${className}`} data-id="element-267">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto px-5 md:px-8" data-id="element-268">
        {children}
      </motion.div>
    </section>;
}